import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { DocsService } from '../../services/docs.service';
import { DataDocAge, PD_TRACCIATURA_DOC_WEB_AGENTI } from '../../classes/doc-age-data.model';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'molla-order-status-list',
  templateUrl: './order-status-list.component.html',
  styleUrls: ['./order-status-list.component.scss']
})
export class OrderStatusListComponent implements OnInit, AfterViewInit {
  @Input() COD_AGE: string;
  
  loaded = false;
  iOrdAge!: DataDocAge;
  perPage = 10;
  totalCount = 0;
  currentPage = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  displayedColumns: string[] = ['DOC_ID', 'DATA_DOC', 'RAG_SOC_CF', 'IMPONIBILE_V1', 'FLAG_EVASO', 'SITUAZIONE_ORDINE'];
  // Additional 'filter' column list
  displayedColumnFilters: string[] = ['DOC_ID-filter', 'DATA_DOC-filter', 'RAG_SOC_CF-filter', 'IMPONIBILE_V1-filter', 'FLAG_EVASO-filter', 'SITUAZIONE_ORDINE-filter'];
  model: NgbDateStruct;
	date: { year: number; month: number };

  dataSource = new MatTableDataSource<PD_TRACCIATURA_DOC_WEB_AGENTI>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  public objFiltri: any = {
    daData: '',
    aData: '',
    DOC_ID: '',
    RAG_SOC_CF: '',
    FLAG_EVASO: '',
    SITUAZIONE_ORDINE: ''
  };

  constructor(
    private docService: DocsService,
    private _liveAnnouncer: LiveAnnouncer
  ) {

  }

  ngOnInit(): void {
    //console.log("Received COD_AGE:", this.COD_AGE);
    this.loadData();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  async loadData() {
    try {

      const yearNow = new Date().getFullYear();
      this.objFiltri.daData = `${yearNow - 6}-01-01`;
      this.objFiltri.aData = `${yearNow}-12-31`;
      
      this.iOrdAge = await this.docService.fetchOrdAge(
                    "",
                    this.COD_AGE,
                    this.COD_AGE,
                    this.objFiltri.daData,
                    this.objFiltri.aData,
                    this.objFiltri.DOC_ID,
                    this.objFiltri.RAG_SOC_CF,
                    this.objFiltri.FLAG_EVASO,
                    this.objFiltri.SITUAZIONE_ORDINE);

      if (this.iOrdAge) {
        this.dataSource.data = this.iOrdAge.documenti;
        this.dataSource.sort = this.sort;

        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = Number(this.iOrdAge.totalCount);
        });

        this.loaded = true;
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }

  pageChanged(event: PageEvent) {
    this.loaded = false;
    this.perPage = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  filterchanged(event: any, columnName: string): void {
    const filterValue = event.target.value;

    switch (columnName) {
      case 'DOC_ID':
        this.objFiltri.DOC_ID = filterValue;
        break;
      case 'RAG_SOC_CF':
        this.objFiltri.RAG_SOC_CF = filterValue;
        break;
      case 'FLAG_EVASO':
        this.objFiltri.FLAG_EVASO = filterValue;
        break;
      case 'SITUAZIONE_ORDINE':
        this.objFiltri.SITUAZIONE_ORDINE = filterValue;
        break;
      // Aggiungi altri casi per le colonne aggiuntive
      default:
        break;
    }

    this.loadData();
  }

}
